import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER_API_URL,
});

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    // const token = getUserFromLocalStorage();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  (response) => {
    // Automatically unwrap the 'data' field if the response follows the new standard
    if (
      response.data &&
      (response.data.status === "success" || response.data.status === "partial_success") &&
      response.data.data !== undefined
    ) {
      response.data = response.data.data;
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Don't redirect if we are already on the login page or trying to login
      const url = error.config.url || "";
      const isLoginRequest = url.includes("/login");
      if (!isLoginRequest) {
        localStorage.clear();
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default API;
